import Ajv from "ajv";
import DROOLS from '../../node_modules/drools/package.json';

const ajv = new Ajv({
  useDefaults: true,
  allErrors: true,
  jsonPointers: true
});

class ValidationService {
  validators = {}

  init = () => {
    if(DROOLS["app-framework"] && DROOLS["app-framework"]["actions"]) {
      this.validators = {
        ...this.validators,
        ...Object.fromEntries(Object.entries(DROOLS["app-framework"]["actions"])
        .map(([name, value]) => [`@drools/${name}`, ajv.compile(value)]))
      };
    }
  };

  validateable = (action) => this.validators[action.type]

  validate = async (action) => this.validators[action.type](action.payload)
}

const inst = new ValidationService();
inst.init();
export default inst;
